<div
  class="palantir-banner"
  [ngClass]="['palantir-banner__theme--' + theme(), 'palantir-banner__variant--' + variant()]"
>
  <ng-content />
</div>
